export default {
    ecommerceChildDisabledInfo: {
        dataTrackId: 'ecommerce-child-disabled-info',
        dataTrackLinkname: 'netthandel last info til barn',
    },
    ecommerceTeenagerDisabledInfo: {
        dataTrackId: 'ecommerce-teenager-disabled-info',
        dataTrackLinkname: 'netthandel last info til tenaring',
    },
    ecommerceChildInfo: {
        dataTrackId: 'ecommerce-child-info',
        dataTrackLinkname: 'netthandel barn info',
    },
    ecommerceInfoButton: {
        dataTrackId: 'ecommerce-info-button',
        dataTrackLinkname: 'netthandel infoknapp',
    },
    ecommerceToggle: {
        dataTrackId: 'ecommerce-toggle',
        dataTrackLinkname: 'toggle netthandel-innstillinger',
    },
    ecommerceToggleSwitch: {
        dataTrackId: 'ecommerce-toggle-switch',
        dataTrackLinkname: 'toggle knapp netthandel-innstillinger',
    },
    ecommerceForm: {
        dataTrackId: 'ecommerce-form',
        dataTrackLinkname: 'netthandel skjema',
    },
    ecommerceInfo: {
        dataTrackId: 'ecommerce-info',
        dataTrackLinkname: 'info om netthandel',
    },
    regionBlockFormBlockedUnder18: {
        dataTrackId: 'region-block-form-blocked-under-18',
        dataTrackLinkname: 'regionsperre skjema last under 18',
    },
    regionBlockRegionOption: {
        dataTrackId: 'region-block-region-option',
        dataTrackLinkname: 'regionsperre region alternativ',
    },
    regionBlockRegionWarning: {
        dataTrackId: 'region-block-region-warning',
        dataTrackLinkname: 'regionsperre advarsel',
    },
    regionBlockForm: {
        dataTrackId: 'region-block-form',
        dataTrackLinkname: 'regionsperre skjema',
    },
    regionBlockToggleList: {
        dataTrackId: 'region-block-toggle-list',
        dataTrackLinkname: 'regionsperre regionalternativer',
    },
    regionBlockSaving: {
        dataTrackId: 'region-block-saving',
        dataTrackLinkname: 'regionsperre lagrer',
    },
    regionBlockSaved: {
        dataTrackId: 'region-block-saved',
        dataTrackLinkname: 'regionsperre lagret',
    },
    regionBlockSaveFail: {
        dataTrackId: 'region-block-save-fail',
        dataTrackLinkname: 'regionsperre fikk ikke lagret',
    },
    regionBlockAndEcommerceForm: {
        dataTrackId: 'region-block-and-ecommerce-form',
        dataTrackLinkname: 'regionsperre og netthandel skjema',
    },
};
